import { encryptRequest, decryptResponse, produceAESKey } from "./cryptoHelper";
import { apiGet, apiPost } from "./apiClient";

const baseHeaders = { 'Content-Type': 'application/json' };

export const getQuestionsFromAPI = async (token) => {
    const { aesKeyBase64, encryptedAESKey } = produceAESKey();

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        queryStringParameters: { encryptedKey: encryptedAESKey },
    };

    const response = await apiGet('/questions', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};

export const addQuestionFromAPI = async (token, obj) => {
    const { encryptedData, encryptedAESKey, aesKeyBase64 } = encryptRequest(obj);

    const requestInfo = {
        headers: { ...baseHeaders, Authorization: token },
        body: { encryptedData, encryptedAESKey },
    };

    const response = await apiPost('/questions', requestInfo);
    return decryptResponse(response, aesKeyBase64);
};
